import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import axios from 'axios';
import { useState } from 'react';
import { AUTH0_HEADER_PREFIX } from '../AuthProvider';

// TODO if we move to an API gateway this HOC can be simplified.
export const API_ENDPOINTS = {
  mediaServers: (process.env.REACT_APP_CAIRO_NMS_ADMIN_URLS &&
    JSON.parse(process.env.REACT_APP_CAIRO_NMS_ADMIN_URLS)) || [
    {
      adminUrl: 'http://localhost:8080',
      description: 'NMS Server: One',
      order: 1,
      serviceUrl: 'http://localhost:4000',
    },
    {
      adminUrl: 'http://localhost:8081',
      description: 'NMS Server: Two',
      order: 2,
      serviceUrl: 'http://localhost:4001',
    },
    {
      adminUrl: 'http://localhost:8082',
      description: 'NMS Server: Three',
      order: 3,
      serviceUrl: 'http://localhost:4002',
    },
    {
      adminUrl: 'http://localhost:8083',
      description: 'NMS Server: Four',
      order: 4,
      serviceUrl: 'http://localhost:4003',
    },
    {
      adminUrl: 'http://localhost:8084',
      description: 'NMS Server: Five',
      order: 5,
      serviceUrl: 'http://localhost:4004',
    },
  ],
  videoService:
    process.env.REACT_APP_VIDEO_SERVICE_URL || 'http://localhost:19820',
};

const AWS_URL_PART = 'amazonaws.com';
/**
 * Simple API helper function to allow for calling multiple APIs and handling common state. For example:
 * - fetching status
 * - error messages
 *
 * @returns {{
 *   delete: function(*): Promise<AxiosResponse<any>>,
 *   errorMessage: [String],
 *   get: function(*): Promise<AxiosResponse<any>>,
 *   head: function(*): Promise<AxiosResponse<any>>,
 *   isFetching: Boolean,
 *   options: function(*): Promise<AxiosResponse<any>>,
 *   patch: function(*): Promise<AxiosResponse<any>>,
 *   post: function(*): Promise<AxiosResponse<any>>,
 *   put: function(*): Promise<AxiosResponse<any>>
 *   response: AxiosResponse<any>,
 *   clearErrorMessage: function()
 * }}
 */
export default function useApi() {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [response, setResponse] = useState(null);

  const authState = useKitbagAuth();
  const { getAccessTokenSilently } = authState;

  /**
   * @param {String} url
   * @param {Object} options - Axios request options
   * @returns {Promise<AxiosResponse<any>>}
   */
  const call = async (url, options = {}) => {
    let result;
    let error = null;

    const authToken = await getAccessTokenSilently();
    const authPrefix = AUTH0_HEADER_PREFIX;

    setIsFetching(true);

    const fullOptions = url.includes(AWS_URL_PART)
      ? { ...options }
      : {
          ...options,
          headers: {
            ...options.headers,
            Authorization: `${authPrefix}${authToken}`,
          },
        };

    try {
      result = await axios({
        ...fullOptions,
        url,
      });
    } catch (err) {
      error = err.message;
    }

    setIsFetching(false);
    setErrorMessage(error);
    setResponse(result);
    return result;
  };

  const createAlias = (method) => (url, options) =>
    call(url, {
      ...options,
      method,
    });

  const api = {
    delete: createAlias('DELETE'),
    get: createAlias('GET'),
    head: createAlias('HEAD'),
    options: createAlias('OPTIONS'),
    patch: createAlias('PATCH'),
    post: createAlias('POST'),
    put: createAlias('PUT'),
  };

  return {
    ...api,
    clearErrorMessage: () => setErrorMessage(null),
    errorMessage,
    isFetching,
    response,
  };
}
